import { useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { AvatarBoError } from '../../shared/AvatarBoClient'
import { shouldRetry } from '../../shared/retry'
import type { AvatarBoClient } from '../../shared/types'

export const tierBandsKeys = {
  bands: () => ['avatar-bo', 'tier-bands'] as const,
}

export function useTierBands(client: AvatarBoClient) {
  const qc = useQueryClient()
  const [apiError, setApiError] = useState<string | null>(null)

  const query = useQuery(tierBandsKeys.bands(), () => client.getTierBands(), {
    refetchOnWindowFocus: false,
    retry: shouldRetry,
  })

  const save = useMutation((bands: number[]) => client.setTierBands(bands), {
    onMutate: () => setApiError(null),
    onSuccess: () => {
      qc.invalidateQueries(tierBandsKeys.bands())
    },
    onError: (error: unknown) => {
      setApiError(
        error instanceof AvatarBoError && error.issues.length
          ? error.issues.map((i) => i.detail ?? i.code).join(' ')
          : error instanceof Error
            ? error.message
            : String(error),
      )
    },
  })

  return { query, save, apiError }
}
